<template>
    <div>
        <ui-modal size="large" ref="editModal" :title="(this.item.id ? 'Edit Invoice Item #' + this.item.id : 'Add Invoice Item')" @hide="$emit('hide')" dismiss-on="close-button esc">
            <div class="container-fluid" style="padding: 0; margin-top: 1rem;">
                
                <div class="row">
                    <div class="col-5">
                        <ui-select
                            label="Item Type"
                            :disabled="!isNewItem && (isVehicleSale||isSettlement||isWarrantySale)"
                            v-model="typeProxy"
                            :options="InvoiceItemTypeList"
                            placeholder="Select item type"
                        ></ui-select>
                    </div>

                    <div class="col-12" v-if="isVehicleSale">
                        <vehicle-picker
                            label="Related Vehicle"
                            v-model="instanceProxy"
                            :disabled="disableInstanceSelection"
                            :force-alien-lookup="false"
                            @input="updateItemDetails"
                        ></vehicle-picker>
                    </div>

                 </div>
                 <div class="row">

                    <div class="col-5">
                        <ui-textbox
                            label="Item Description"
                            v-model="item.description"
                        ></ui-textbox>
                    </div>

                    <div class="col-2">
                        <ui-textbox
                            label="SKU"
                            v-model="item.sku"
                            :disabled="isWarrantySale"
                        ></ui-textbox>
                    </div>

                    <div class="col">
                        <ui-textbox
                            label="Qty"
                            v-model="item.quantity"
                            type="number"
                            :disabled="isVehicleSale||isSettlement||isWarrantySale"
                        ></ui-textbox>
                    </div>
                    
                    <div class="col-2">
                        <ui-textbox
                            label="Unit Net £'s"
                            v-model="item.unit_cost"
                            type="number"
                            step="5"
                        ></ui-textbox>
                    </div>
                    <div class="col-2">
                        <vat-rate-selector
                            v-model="item.vat_rate"
                            :disabled="isSettlement"
                        />
                    </div>
                </div>

            </div>
            <div slot="footer">
                <button class="btn btn-primary" @click="save" :disabled="!canSubmit">{{ buttonLabel }}</button>
            </div>
        </ui-modal>
    </div>
</template>

<script>
    import { VatTariffs } from '../../classes/VatService'
    import { InvoiceItemSchema, InvoiceCategorySchema, InvoiceItemTypeList, InvoiceItemTypes } from '../../classes/Api/Invoice'
    import VehiclePicker from './controls/KeenVehiclePicker'
    import VatRateSelector from './controls/VatRateSelector'
    import {VehicleInvoiceItemFactory} from "../../classes/VehicleInvoiceItemFactory";

    export default {
        components: { VehiclePicker, VatRateSelector },
        props: {
            instance: {
                type: Object,
                required: false,
                default: null
            },
            disableInstanceSelection: {
                type: Boolean,
            }
        },
        data() {
            return {
                InvoiceItemTypes,
                InvoiceItemTypeList,
                item: new InvoiceItemSchema({
                    instance: {},
                    category: {},
                }),
            }
        },
        methods: {
            categoryChange(e) {
                if (e.id === this.defaultVehicleInvoiceCategory.id) {
                    this.updateItemDetails(this.item.instance);
                }
            },
            updateItemDetails(value) {
                if (InvoiceItemTypes.TYPE_VEHICLE === this.item.type) {
                    this.item = Object.assign(this.item, VehicleInvoiceItemFactory.newFrom(value, value.retail_price))
                }
            },
            open(item = null) {
                if (item) {
                    this.item = item;
                } else {
                    this.item = new InvoiceItemSchema({
                        instance: {},
                        expense_category: {},
                    });

                    this.instanceProxy = { id: null };
                    this.typeProxy = { id: null };
                }

                if (this.instance && (!this.item.instance || !this.item.instance.id) && !this.item.id) {
                    this.instanceProxy = this.instance;
                }

                this.$refs['editModal'].open();
            },
            close() {
                this.$refs['editModal'].close();
            },
            save() {
                let item = Object.assign({}, this.item);

                this.$emit('save', item);

                this.$refs['editModal'].close();
            }
        },
        computed: {
            shouldShowPurchasePriceOption() {
                return this.instanceProxy && this.instanceProxy.id;
            },
            isNewItem() {
                return !this.item.id
            },
            isVehicleSale() {
                return this.item.type === InvoiceItemTypes.TYPE_VEHICLE
            },
            isSettlement() {
                return this.item.type === InvoiceItemTypes.TYPE_PART_EXCHANGE_SETTLEMENT
            },
            isWarrantySale() {
                return this.item.type === InvoiceItemTypes.TYPE_WARRANTY || 
                    this.item.type === InvoiceItemTypes.TYPE_EXEMPT_LINKED_WARRANTY ||
                    this.item.type === InvoiceItemTypes.TYPE_GAP_RTI_INSURANCE
            },
            canSubmit() {
                return this.item.description && this.item.description.length > 0 && 
                    this.item.quantity > 0 && 
                    this.item.unit_cost !== null && 
                    this.item.type;
            },
            buttonLabel() {
                return this.item.id > 0 ? 'Update' : 'Add';
            },
            instanceProxy: {
                get() {
                    let instance = Object.assign({}, this.item.instance);

                    return instance;
                },
                set(value) {
                    this.$set(this.item, 'instance', value);
                    this.$set(this.item, 'instance_id', value.id ? value.id : null);
                }
            },
            typeProxy: {
                get() {
                    let type = this.InvoiceItemTypeList.find(item => {
                        return item.value === this.item.type;
                    })

                    return type ? type : ''
                },
                set(value) {
                    this.item.type_text = value.label;
                    this.item.type = value.value;
                }
            }
        }
    }
</script>